<template>
  <router-view />
  
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>



<style lang="scss">

/* :root {
  --navbar-height: 80px; 
} */

// Main
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  text-align: center;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center; /* Centra horizontalmente */
  align-items: center;
  margin: auto;
}

@media screen and (max-device-width: 768px) {
  #app {
    height: 95vh;
  }
}
</style>
